import { ReportsQueries } from "../store/types";

export default function (
  queries: Partial<Pick<ReportsQueries, "measures" | "calculatedFields" | "characteristics" | "secondaryPricing">>,
  currentColumns: ReportsQueries["reportTableColumns"]
) {
  const aggregations = [
    ...(queries.measures || []),
    ...(queries.calculatedFields || []),
    ...(queries.characteristics || []),
    ...(queries.secondaryPricing || [])
  ];

  const synced = currentColumns.filter((col) => aggregations.includes(col.aggregation));
  const newAggregations = aggregations.filter((agg) => !currentColumns.map((col) => col.aggregation).includes(agg));
  newAggregations.forEach((aggregation) => {
    synced.push({ aggregation, key: aggregation });
  });

  return synced;
}
